import * as R from 'remeda';

export interface Mesh {
  id: number;
  type: string;
  preferredOrder: number;
  isSupplemental?: boolean;
}

export interface SupplementalMesh {
  meshId: number;
  meshName: string;
  materialNumber: string;
  salesOrderLineItem: string;
}

export interface GroupedMeshes {
  storageId: number;
  meshName: string;
  meshes: Mesh[];
}

export const sortByPreferredOrder: <T extends Mesh>(meshes: T[]) => T[] = R.sort((a, b) =>
  a.preferredOrder < b.preferredOrder ? -1 : 1,
);
